import round from "lodash/round";
import { cn } from "@/lib/utils";
import { okrPct } from "./okrConstants";

interface OkrProgressBarProps {
  progress: number;
  targetProgress?: number;
  className?: string;
  showLabel?: boolean;
}

/** Read-only: objective progress is derived on the BE from KR weights; KR progress is edited in its form. */
export function OkrProgressBar({ progress, targetProgress = 100, className, showLabel = true }: OkrProgressBarProps) {
  const percentage = okrPct(progress, targetProgress);

  const colorClass =
    percentage >= 100
      ? "bg-emerald-500"
      : percentage >= 70
        ? "bg-blue-500"
        : percentage >= 30
          ? "bg-amber-500"
          : "bg-muted-foreground/50";

  return (
    <div className={cn("flex items-center gap-2", className)}>
      <div className="relative h-2 flex-1 overflow-hidden rounded-full bg-secondary">
        <div className={cn("h-full rounded-full transition-all", colorClass)} style={{ width: `${percentage}%` }} />
      </div>
      {showLabel && (
        <span className="text-xs font-medium text-muted-foreground w-12 text-right tabular-nums">
          {round(progress, 0)}/{round(targetProgress, 0)}
        </span>
      )}
    </div>
  );
}
